<template>
  <el-header height="46px" :class="[this.$store.state.sysInit.personalSingleMode == 'STAND_MIC_MODE'?'background-image-stand-mic':(this.$store.state.sysInit.personalSingleMode == 'NEXMO_ASTERISK_PBX_MODE'?'background-image-tel':'background-image-manual-chat')]" :style="cssVars">
    <!-- <h4>IBM AICC Watson AI Assistant</h4> -->
    <h4>{{this.$store.state.sysInit.html_const.cons_201_title}}</h4>
    <section class="header-info">
      <div class="search">
        <el-form @submit.native.prevent>
          <el-input size="mini" class="search-input" prefix-icon="el-icon-search" v-model="input" :placeholder="this.$store.state.sysInit.html_const.cons_202_search_input_placeholder" 
          @keypress.enter.native="onSubmit()">
          <i slot="suffix"
          class="el-input__icon el-icon-circle-close el-input__clear"
          @click="clearInput"
          v-if="input !== ''"></i>
          </el-input>
        </el-form>
      </div>
       <div class="action outDiv" v-if="this.$store.state.sysInit.showPiButton=='ok'">
         <div :class="[callBlingbling ?'blingbling':'notBlingbling']">
        <el-tooltip class="item" effect="dark" content="CTI" placement="bottom" >
          <span @click="showPi">
           <icon name="pi"></icon>
          </span>
        </el-tooltip>
         </div>
      </div>
       <div class="action outDiv" v-if="this.$store.state.sysInit.showChatPiButton=='ok'">
         <div :class="[this.$store.state.sysInit.isBlingFlg? 'blingbling':'notBlingbling']">
          <el-tooltip class="item" effect="dark" content="CTI" placement="bottom" >
          <span @click="showChatPi">
           <icon name="pi"></icon>
          </span>
        </el-tooltip>
            </div>
      </div>
       <div class="action" v-if="this.$store.state.sysInit.showChatPiButton=='ok'">
      <PiStatusButton></PiStatusButton>
       </div>

      <div class="action outDiv"  v-if="$store.state.sysInit.ws_mode == 'NEXMO_ASTERISK_PBX_MODE'">
        <div :class="[this.$store.state.store_sv.sv_help_isBlingFlg && this.$store.state.store_sv.phone_sv_help_status == 'iscalling' ? 'blingbling_sv':'notBlingbling']">
             <el-tooltip class="item" effect="dark" content="sv help" placement="bottom">
               <span v-if="!this.$store.state.store_sv.sv_help_onSupportFlg">
                  <span @click="doSvHelp" v-if="(this.$store.state.sysInit.personalEnable == 0 ||
              this.$store.state.stt.isMicOn||
              this.$store.state.sysInit.manualChatUserCount > 0 ) ">
            <icon name="LeftHand"></icon>
          </span>
              <span v-else>
            <icon name="LeftHand"></icon>
          </span>
               </span>
               <span v-if="this.$store.state.store_sv.sv_help_onSupportFlg ">
             <span  :class="[!this.$store.state.store_sv.sv_help_phone_end? 'notBlingbling_sv':'notBlingbling_sv_phone']" @click="showSvHelperDialog" v-if="(this.$store.state.sysInit.personalEnable == 0 ||
              this.$store.state.stt.isMicOn||
              this.$store.state.sysInit.manualChatUserCount > 0 )&& this.$store.state.store_sv.phone_sv_help_status == 'iscalling'"
              >
              <!-- {{this.$store.state.store_sv.phone_sv_help_status}} -->
            <icon name="LeftHand"></icon>
          </span>
              <span v-else>
            <icon name="LeftHand"></icon>
          </span>

               </span>
        
        </el-tooltip>
           </div>

  
         
        
      </div>
      

      <div class="action outDiv"  v-if="$store.state.sysInit.ws_mode == 'STAND_MIC_MODE'">
           <div :class="[this.$store.state.store_sv.sv_help_isBlingFlg? 'blingbling_sv':'notBlingbling']">
             <el-tooltip class="item" effect="dark" content="sv help" placement="bottom">
               <span v-if="!this.$store.state.store_sv.sv_help_onSupportFlg">
                  <span @click="doSvHelp" v-if="this.$store.state.sysInit.personalEnable == 0 ||
              this.$store.state.stt.isMicOn||
              this.$store.state.sysInit.manualChatUserCount > 0">
            <icon name="LeftHand"></icon>
          </span>
              <span v-else>
            <icon name="LeftHand"></icon>
          </span>
               </span>
               <span v-if="this.$store.state.store_sv.sv_help_onSupportFlg">
             <span  class="notBlingbling_sv" @click="showSvHelperDialog" v-if="this.$store.state.sysInit.personalEnable == 0 ||
              this.$store.state.stt.isMicOn||
              this.$store.state.sysInit.manualChatUserCount > 0">
            <icon name="LeftHand"></icon>
          </span>
              <span v-else>
            <icon name="LeftHand"></icon>
          </span>

               </span>
        
        </el-tooltip>
           </div>
        
      </div>

      <div class="chat2Tel" v-if="$store.state.sysInit.ws_mode == 'MANUAL_CHAT_MODE'">
        <img src="../assets/img/chat2Tel.svg" style="height:23px;width:23px"
          @click="showChat2TelDialog" v-if="this.$store.state.sysInit.manualChatPiStatus == 'OnThePhone'
          && this.$store.state.store_sv.chat_current_customer_status != 'waitClose' &&
          this.$store.state.store_sv.chat_current_customer_status != 'waitAssign' &&
          this.$store.state.store_sv.chat_current_customer_status != 'ending'">
        <img src="../assets/img/chat2Tel.svg" style="height:23px;width:23px" v-else>
      </div>

       <div class="action outDiv_sv_talk" v-if="$store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'" >
         <div :class="[this.$store.state.store_sv.isSvTalkBlingFlg? 'blingbling_sv_talk':'notBlingbling_sv_talk']">
             <el-tooltip class="item" effect="dark" content="sv talk" placement="bottom">
          <span  v-if="this.$store.state.sysInit.personalEnable == 0 ||
              this.$store.state.stt.isMicOn||
              this.$store.state.sysInit.manualChatUserCount > 0">
            <icon name="messageTalk"></icon>
          </span>
           <span  v-else>
            <icon name="messageTalk"></icon>
          </span>
        </el-tooltip>
         </div>
      
      </div>


      <div class="action outDiv" v-if="$store.state.sysInit.ws_mode == 'MANUAL_CHAT_MODE'" >
           <div :class="[this.$store.state.store_sv.sv_help_isBlingFlg && this.$store.state.store_sv.chat_current_customer_status != 'waitClose' && this.$store.state.store_sv.chat_current_customer_status != 'waitAssign' && this.$store.state.store_sv.chat_current_customer_status != 'ending' ? 'blingbling_sv':'notBlingbling']">
             <el-tooltip class="item" effect="dark" content="sv help" placement="bottom">
               <span v-if="!this.$store.state.store_sv.sv_help_onSupportFlg">
                  <span @click="doSvHelp" v-if="this.$store.state.sysInit.manualChatPiStatus == 'OnThePhone' && this.$store.state.store_sv.chat_current_customer_status != 'waitClose' && this.$store.state.store_sv.chat_current_customer_status != 'waitAssign' && this.$store.state.store_sv.chat_current_customer_status != 'ending' ">
            <icon name="LeftHand"></icon>
          </span>
              <span v-else>
            <icon name="LeftHand"></icon>
          </span>
               </span>
               <span v-if="this.$store.state.store_sv.sv_help_onSupportFlg">
             <span class="notBlingbling_sv" @click="showSvHelperDialog" v-if="this.$store.state.sysInit.manualChatPiStatus == 'OnThePhone' && this.$store.state.store_sv.chat_current_customer_status != 'waitClose' && this.$store.state.store_sv.chat_current_customer_status != 'waitAssign'&& this.$store.state.store_sv.chat_current_customer_status != 'ending'">
            <icon name="LeftHand"></icon>
          </span>
              <span v-else>
                <!-- <span class="notBlingbling_sv"> -->
                  <icon name="LeftHand"></icon>
                <!-- </span> -->
           
          </span>

               </span>
        
        </el-tooltip>
           </div>
        
      </div>

       <div class="action outDiv_sv_talk"  v-if="$store.state.sysInit.ws_mode == 'MANUAL_CHAT_MODE'">
         <div :class="[this.$store.state.store_sv.isSvTalkBlingFlg? 'blingbling_sv_talk':'notBlingbling_sv_talk']">
             <el-tooltip class="item" effect="dark" content="sv talk" placement="bottom">
          <span @click="showSvTalk" v-if=" this.$store.state.store_sv.sv_help_onSupportFlg && this.$store.state.sysInit.manualChatPiStatus == 'OnThePhone' && this.$store.state.store_sv.chat_current_customer_status != 'waitClose' && this.$store.state.store_sv.chat_current_customer_status != 'waitAssign' && this.$store.state.store_sv.chat_current_customer_status != 'ending' ">
            <icon name="messageTalk"></icon>
          </span>
           <span  v-else>
            <icon name="messageTalk"></icon>
          </span>
        </el-tooltip>
         </div>
      
      </div>

      <!-- <div class="action outDiv-phone"  v-if="$store.state.sysInit.ws_mode == 'NEXMO_ASTERISK_PBX_MODE'">
        <div :class ="phoneBlingbling? 'blingbling' : '' ">
        <el-tooltip class="item" effect="dark" :content="phoneTooltips" placement="bottom">
          <span @click="showPhoneDialog">
            <icon name="phone-status" :color="telColor"></icon>
          </span>
        </el-tooltip>
        </div>
      </div> -->
      <div class="action"  v-if="false">
        <el-tooltip class="item" effect="dark" :content="this.$store.state.sysInit.emotionText" placement="bottom">
          <span @click="showEmotion">
            <icon name="emotion"></icon>
          </span>
        </el-tooltip>
      </div>
      <!-- <div class="action mr-20">
        <el-tooltip class="item" effect="dark" :content="this.$store.state.sysInit.html_const.cons_203_relation_map" placement="bottom">
          <span @click="showMap">
            <icon name="map"></icon>
          </span>
        </el-tooltip>
      </div> -->
      <Time></Time>
      <div class="user">
        <el-popover placement="bottom-end" width="150px" :offset="100" v-model="piStatusPopVisible">
          <PIStatusPop @update-status="updatePiStatus"></PIStatusPop>
          <el-badge is-dot class="avatar-badge" slot="reference">
            <el-avatar :size="32" :src="$store.state.sysInit.ws_mode == 'STAND_MIC_MODE' ? this.$store.state.sysInit.operator_logo_f2f :this.$store.state.sysInit.operator_logo"></el-avatar>
          </el-badge>
        </el-popover>
        <div class="name">
          <p>{{this.$store.state.sysInit.user_name}}</p>
          <!-- <p v-for="name in $store.state.sysInit.user_name.split(' ')" :key="name">{{ name }}</p> -->
        </div>
      </div>
      <div class="action">
        <el-tooltip class="item" effect="dark" content="settings" placement="bottom">
          <span @click="showSettings">
            <icon name="settings"></icon>
          </span>
        </el-tooltip>
      </div>
      <div class="action">
        <el-tooltip class="item" effect="dark" :content="this.$store.state.sysInit.html_const.cons_204_logout" placement="bottom">
          <span class="logout-icon" @click="logoutConfirm">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- ドアの枠 -->
              <rect x="3" y="3" width="9" height="18" rx="1.5" stroke="currentColor" stroke-width="2" fill="none" />
              <!-- ドアの開いた部分（右側の線） -->
              <line x1="12" y1="3" x2="12" y2="21" stroke="currentColor" stroke-width="2" />
              <!-- 右向き矢印 -->
              <path d="M13.5 12 L19.5 12 M16.5 9 L19.5 12 L16.5 15" stroke="currentColor" stroke-width="2" fill="none"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </el-tooltip>
      </div>
    </section>
    
    <el-dialog title="logout" :visible.sync="dialogVisible3" width="30%">
      <span v-html="this.$store.state.sysInit.html_const.cons_250_logout_confirm_title"></span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logout" class="is-red">
          {{this.$store.state.sysInit.html_const.cons_251_logout_confirm_ok}}</el-button>
        <el-button @click="dialogVisible3 = false" type="primary" plain>
          {{this.$store.state.sysInit.html_const.cons_252_logout_confirm_cancel}} </el-button>
      </span>
    </el-dialog>


    <el-dialog title="通話を案内" :visible.sync="chat2TeldialogVisible" width="30%">
      <span>お問い合わせ者へ外線電話番号・内線グループまたは内線番号を案内します。</span>
      <div style="text-align:center">
        <div style="margin:5px">
          <el-select v-model="chat2TelGroup1Value" placeholder="请选择" class="chat2TelGroup" @change="changeChat2TelGroupVal">
            <el-option
              v-for="item in chat2TelGroup1"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="chat2TelGroup2Value" placeholder="请选择" class="chat2TelGroup" v-loading="chat2TelLoading">
            <el-option
              value-key="id"
              v-for="item in chat2TelGroup2"
              :key="item.sipNum"
              :label="item.label"
              :value="item.sipNum">
            </el-option>
          </el-select>
        </div>
      </div>
      <div style="text-align:center;margin-top:10px">
        <el-button @click="chat2TelSend" type="primary">案内を送信</el-button>
        <el-button @click="chat2TeldialogVisible = false" plain>
          {{this.$store.state.sysInit.html_const.cons_252_logout_confirm_cancel}} </el-button>
      </div>
    </el-dialog>
    <!-- for pre load this img -->
    <img src="../assets/img/heart-white-current.svg" v-show="false" rel="preload"/>
  </el-header>
</template>

<script>
  import Time from '@/components/Time.vue'
  import { mapGetters } from 'vuex'
  import{ find } from 'lodash'
  import PiStatusButton from '@/components/PIStatusButton.vue'
  import PIStatusPop from '@/components/PIStatusPop.vue'
  import moment from "moment";
  import api from '@/api';
  import VueUtils from '@/utils/utils.js';
  export default {
    name: 'Header',
    components: {
      Time,
      PiStatusButton,
      PIStatusPop
    },
    props: {},
    data() {
      return {
        chat2TelLoading: false,
        input: "",
        dialogVisible3:false,
        phoneTooltips:'電話',
        badgeColor: '#34785C', // default Online
        // currentStatus:'Offline', // Online:'待機中' OnThePhone: '応対中' Busy:'作業中',Away: '離席中', Offline: '応対不可'
        piStatusPopVisible: false,
        piStatus:'Online',
        chat2TeldialogVisible:false,
        chat2TelGroup1: [{
          value: '0',
          label: '内線番号'
        },
        {
          value: '1',
          label: "内線グループ"
        } 
      ],
        chat2TelGroup2: [],
        chat2TelGroup1Value: '0',
        chat2TelGroup2Value: ''
      }
    },
    watch: {
      currentStatus(newVal){
        this.setBadgeColor()
      },
      '$store.state.sysInit.personalSingleMode':function(newVal){
        if(newVal !='NEXMO_ASTERISK_PBX_MODE'){
          this.piStatus = 'Online'
        }else{
          this.piStatus = 'Offline'
        }
      },
    },
    computed: {
      ...mapGetters('discovery', {
        collections: 'getCollections'
      }),
      telColor(){
        return this.$store.state.phone.callList.filter(item => item.isWaiting && item.is_outbound == '0').length > 0 ? '#CD221F' : this.$store.state.phone.registerStatus == 'registered' ? '#2242EB': this.$store.state.phone.registerStatus == 'unregistered' || this.$store.state.phone.registerStatus == 'disconnected' ? '#f5ff00' : '#FF0000'
      },
      cssVars(){
        return {
          '--badgeColor': this.badgeColor
        }
      },
      currentStatus(){
        if(this.$store.state.sysInit.personalSingleMode == 'NEXMO_ASTERISK_PBX_MODE'){
          if(this.$store.state.phone.inCallList.length>0){
            return 'OnThePhone'
          }
          if(this.$store.state.phone.registerStatus == 'registered'){
            this.piStatus = sessionStorage.getItem('currentStatus_Storage') || 'Away'
            if (this.piStatus == 'Online') {
              this.$SIP.ToggleDoNoDisturb()
            }
            return this.piStatus
          }else if (this.$store.state.phone.registerStatus == 'unregistered' || this.$store.state.phone.registerStatus == 'disconnected') {
            return 'Offline'
          }else if(this.$store.state.phone.registerStatus == 'registerError'){
            return 'registerError'
          }
        }
        return this.piStatus
      },
      callBlingbling(){
        return this.$store.state.phone.waitingList.filter(item => item.is_outbound == '0').length > 0 
      },
      phoneBlingbling(){
        return this.$store.state.phone.callList.filter(item => item.isWaiting && item.is_outbound == '0').length > 0 
      },
    },
    methods: {
      chat2TelSend(){
        this.chat2TeldialogVisible = false;
        let msg = "オペレーターからの通話案内です。<span class='telBtn' onclick='call2OP(\"" + this.chat2TelGroup2Value + "\")'>" 
          + "クリックして発信</span>してください※5分以内かつサポート終了前に発信してください。";
        this.$store.dispatch("sysInit/manualChatSendMessage", {
            message: msg,
        });

        let msg2 = "オペレーターからの通話案内です。<a href='javascript:;'>クリックして発信</a>してください※5分以内かつサポート終了前に発信してください。"
        let data = {
          id: this.$store.state.sysInit.messageId++,
          flag: "left",
          userId: this.$store.state.sysInit.manualChatQuestionerId,
          text: msg2,
          checked: false,
          user: this.$store.state.sysInit.html_const.cons_216_operator,
          messageTime: moment()
            .tz("Asia/Tokyo")
            .format("YYYY-MM-DD HH:mm:ss"),
          status: false,
          issueId: this.$store.state.sysInit.manualChatModeIssueId,
          isChatbot: false,
          username: this.$store.state.sysInit.user_name,
          editorText: msg2,

          // chatbotIssueId:this.$store.state.sysInit.manualChatbotIssueId
        };
        this.$store.state.sysInit.manualChatMessageList.push(data);
        this.$store.dispatch(
          "redmine/manualChatMessageRecord",
          {},
          { root: true }
        );

        let item = {
          flag: data.flag,
          text: data.text,
          mode: this.$store.state.sysInit.ws_mode,
        };

        this.$store.dispatch("stt/fetchKeywordByDialog", {
          ...item,
          request_id: this.$store.state.redmine.issue_id,
          keywordRate: this.$store.state.sysInit.keywordRate,
        });
      },
      changeChat2TelGroupVal(val) {
        if(this.chat2TelGroup2Value !== val) {
          this.chat2TelGroup1Value = val
          this.chat2TelGroup2 = []
          val == '0' ? this.showChat2TelDialog() : (this.chat2TelGroup2 = [{
            label: "01000（ITヘルプ）",
            sipNum: "01000"
          },
          {
            label: "02000（総合ヘルプ）",
            sipNum: "02000"
          },
        ], this.chat2TelGroup2Value = this.chat2TelGroup2[0].sipNum)
        }
      },
      showChat2TelDialog(){
        this.chat2TelLoading = true
        api.getPbxUserStatus(this.$store.state.sysInit.user_id).then((res) => {
          if(res.data.result && res.data.result.length){
            this.chat2TelGroup2 = res.data.result.filter(d => d.presence == 'Online').map(d => ({...d, label: `${d.sipNum}（${VueUtils.computeFullName(d.lastname, d.firstname)}）`}))
            if(this.chat2TelGroup2.length) {
              this.chat2TelGroup1Value = '0'
              this.chat2TelGroup2Value = this.chat2TelGroup2[0].sipNum
            } else {
              this.changeChat2TelGroupVal('1')
            }
            this.chat2TeldialogVisible = true;
          }
        }).catch((err) => {
          console.log(err);
        }).finally(() => {
          this.chat2TelLoading = false
        })

      },

      showPhoneDialog() {
        this.$store.dispatch('phone/setShowPhone', !this.$store.state.phone.showPhone)
      },
      onSubmit() {
        if (!this.input) return false;
        this.$store.dispatch("sysInit/changeQueryNote", this.input);
        // this.$store.commit("sysInit/changeNavigationText", "テキスト検索にて関連度の高いナレッジを表示しました");
        this.$store.commit("sysInit/changeNavigationText", this.$store.state.sysInit.html_const.cons_235_footer_search_button);

        
        // for (const collection of this.collections) {
          this.$store.dispatch("discovery/fetchDisResults", { collections: this.collections, input: this.input, search_flag: 'dis' });
        // }
        this.$store.dispatch("openAi/openAiSearch",{ userContent:this.input})

        // this.$store.dispatch("discovery/fetchDocumentDisResults", 
        // { collections: this.$store.state.discovery.documentSearchCollection, input: this.input, search_flag: 'dis-web-crawl' });
      },
      showMap() {
        if(this.$store.state.echart.mapShowFlag){
          this.$modal.hide('map');
          this.$modal.hide('minmap'); 
        }else{
          this.$emit('showMap')
        }
        this.$store.commit("echart/changeMapFlag",!this.$store.state.echart.mapShowFlag);
      },
      showEmotion() {
        if(this.$store.state.echart.emotionShowFlag){
          this.$modal.hide('emotion');
          this.$modal.hide('minemotion'); 
        }else{
          this.$emit('showEmotion')
        }
        this.$store.commit("echart/changeEmotionFlag",!this.$store.state.echart.emotionShowFlag);
      },
      logoutConfirm(){
        this.dialogVisible3 = true ;
      },
      logout(){
        this.$store.dispatch("sysInit/logout");
      },
      clearInput(){
        this.input = '';
      },
      showSettings(){
        this.$store.commit("echart/changeSettingsFlag",!this.$store.state.echart.settingShowFlag);
        this.$store.state.sysInit.temp_VoiceConnectionMode =  this.$store.state.sysInit.personalSingleMode
        this.$store.state.sysInit.temp_VoiceConvertMode = this.$store.state.sysInit.showImmediately;
        },

      showPi(){
          this.$store.state.sysInit.piDiaLogVisible = true;
          this.$store.state.sysInit.isBlingFlg_call = false;
          // this.$store.dispatch("sysInit/testCallInfo");
          this.$store.dispatch("sysInit/getPiCallInfo");
          // this.$store.dispatch("sysInit/connectPiWs");
      },
      showChatPi(){
        this.$store.state.sysInit.chatPiDiaLogVisible = true;
        this.$store.state.sysInit.isBlingFlg = false;
        console.log("this.$store.state.sysInit.chatPiDiaLogVisible:",this.$store.state.sysInit.chatPiDiaLogVisible)
          this.$store.dispatch("sysInit/getManualChatCurrentTime");
          // this.$store.dispatch("sysInit/connectChatPiSocket");
      },
      doSvHelp(){
        if(this.$store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'){
            this.$store.dispatch("store_sv/svHelpRequest_phone_f2f",);
        }else{
            this.$store.dispatch("store_sv/svHelpRequest_chat",);
        }
      },
     showSvTalk(){
       this.$store.state.store_sv.isSvTalkBlingFlg = false;
        console.log( this.$store.state.store_sv.svTalkDiaLogVisible)
         if(this.$store.state.sysInit.ws_mode != 'NEXMO_ASTERISK_PBX_MODE'){
        this.$store.state.store_sv.svTalkDiaLogVisible = true;
         }else{
           if(!this.$store.state.store_sv.sv_help_phone_end){
               this.$store.state.store_sv.svTalkDiaLogVisible = true;
           }
         }
      },
      showSvHelperDialog(){
         console.log(this.$store.state.store_sv.sv_help_onSupport_DiaLogVisible)
          if(this.$store.state.sysInit.ws_mode != 'NEXMO_ASTERISK_PBX_MODE'){
              this.$store.state.store_sv.sv_help_onSupport_DiaLogVisible = true;
          }else{
            if(!this.$store.state.store_sv.sv_help_phone_end){
               this.$store.state.store_sv.sv_help_onSupport_DiaLogVisible = true;
            }
          }
        
      },
      updatePiStatus(status) {
        this.piStatusPopVisible = false
        // 电话模式下状态更新
        if(this.$store.state.sysInit.personalSingleMode == 'NEXMO_ASTERISK_PBX_MODE'){
          if(this.currentStatus =='Away' && status == 'Online'){
            this.$SIP.RefreshRegistration()
          }
          if(status == 'Offline'){
            this.$SIP.Unregister()
          }
          if(status == 'Busy' || status == 'Away') {
            this.$SIP.ToggleDoNoDisturb(true)
          } else {
            this.$SIP.ToggleDoNoDisturb()
          }
        }
        this.piStatus = status
        console.log(this.piStatus);
      },
      setBadgeColor(){
        console.log('setBadgeColor...',this.currentStatus)
        switch(this.currentStatus){
          case 'Online' :
            this.badgeColor = '#34785C';
            break;
          case 'OnThePhone':
            this.badgeColor = '#B3C16F';
            break;
          case 'Busy':
            this.badgeColor = '#CE8654';
            break;
          case 'Away':
            this.badgeColor = '#5F5F5F';
            break;
          case 'Offline':
            this.badgeColor = '#f5ff00';
            break;
          case 'registerError':
            this.badgeColor = '#FF0000';
            break;
        }
      },
      // 查询所有用户
      getAllUsers() {
        this.$store.dispatch("sysInit/getAllUsers");
      }
    },
    created() {
      let titleHtml = find(this.$store.state.sysInit.html_const,{id:'cons_201_title'});
      // console.log(titleHtml)
      if(titleHtml && titleHtml.const){
        this.title = titleHtml.comment ;
      }
      let status = sessionStorage.getItem('currentStatus_Storage') || 'Away'
      this.updatePiStatus(status)
      // 查询所有用户
      this.getAllUsers();
    },
    mounted() {}
  }

</script>
<style lang="scss" scoped>
.chat2TelGroup{
 border:1px solid lightgrey;
}

.chat2Tel{
  margin-left: 15px;
}
.outDiv {
padding-left:20px;
padding-right:18px;
display: flex;
justify-content: center;
align-items: center;

.blingbling {
position: absolute;
-webkit-animation: scaleout 1.5s infinite ease-in-out;
animation: scaleout 1.5s infinite ease-in-out;
color: red;

}
.blingbling_sv {
position: absolute;
-webkit-animation: scaleout 1.5s infinite ease-in-out;
animation: scaleout 1.5s infinite ease-in-out;
color: #68379A;

}

.notBlingbling{
position: absolute;
}
.notBlingbling_sv{
color: #68379A;
}
.notBlingbling_sv_phone{
  // position: absolute;
}

@-webkit-keyframes scaleout {
0% {
-webkit-transform: scale(1.0)
}

100% {
-webkit-transform: scale(1.1);
opacity: 0;
}

}

@keyframes scaleout {
0% {
transform: scale(1.0);
-webkit-transform: scale(1.0);
}

100% {
transform: scale(1.1);
-webkit-transform: scale(1.1);
opacity: 0;

}

}

}
.outDiv_sv_talk {
// padding-left:20px;
// padding-right:18px;
display: flex;
justify-content: center;
align-items: center;

.blingbling_sv_talk {
-webkit-animation: scaleout 1.5s infinite ease-in-out;
animation: scaleout 1.5s infinite ease-in-out;
color: #68379A;
// color: #9400D3;

}

.notBlingbling_sv_talk{
//  color: 	#00FFFF;
}

@-webkit-keyframes scaleout {
0% {
-webkit-transform: scale(1.0)
}

100% {
-webkit-transform: scale(1.1);
opacity: 0;
}

}

@keyframes scaleout {
0% {
transform: scale(1.0);
-webkit-transform: scale(1.0);
}

100% {
transform: scale(1.1);
-webkit-transform: scale(1.1);
opacity: 0;

}

}

}
.outDiv-phone {
  display: flex;
  justify-content: center;
  align-items: center;
  .blingbling{
    -webkit-animation: scaleout 1.5s infinite ease-in-out;
    animation: scaleout 1.5s infinite ease-in-out;
  }
  @-webkit-keyframes scaleout {
    0% {
      -webkit-transform: scale(1);
    }

    100% {
      -webkit-transform: scale(1.1);
      opacity: 0;
    }
  }
  @keyframes scaleout {
    0% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }

    100% {
      transform: scale(1.1);
      -webkit-transform: scale(1.1);
      opacity: 0;
    }
  }
}
:deep(.el-badge__content.is-fixed.is-dot){
  right: 8px;
  top:30px;
}
:deep(.el-badge__content.is-dot) {
  height: 12px;
  width: 12px;
}
.avatar-badge {
  color:greenyellow
}
:deep(.el-badge__content) {
  background-color:var(--badgeColor)
}
</style>
